import React from "react";
import { useQuery } from "@apollo/client";
import { Mail, Loader2 } from "lucide-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../ui/tabs";
import { EmailSettings, GET_EMAIL_SETTINGS } from "../../../graphql/email";
import { EmailConfigTab } from "./EmailConfigTab";
import { EmailTemplatesTab } from "./EmailTemplatesTab";
import { EmailLogsTab } from "./EmailLogsTab";

export const EmailNotificationsPage: React.FC = () => {
  const { data, loading, error } = useQuery<{ emailSettings: EmailSettings }>(
    GET_EMAIL_SETTINGS,
    { fetchPolicy: "network-only" }
  );

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-foreground flex items-center gap-2">
          <Mail className="w-8 h-8" />
          Powiadomienia mailowe
        </h2>
        <p className="text-muted-foreground mt-2">
          Konfiguruj dostawcę poczty, edytuj szablony i przeglądaj historię
          wysyłek
        </p>
      </div>

      {loading && (
        <div className="flex items-center justify-center py-16">
          <div className="text-center">
            <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">
              Ładowanie konfiguracji...
            </p>
          </div>
        </div>
      )}

      {error && !loading && (
        <div className="flex items-center justify-center py-16">
          <div className="text-center">
            <p className="text-red-600 mb-2">
              Nie udało się załadować konfiguracji
            </p>
            <p className="text-sm text-muted-foreground">{error.message}</p>
          </div>
        </div>
      )}

      {!loading && !error && data?.emailSettings && (
        <Tabs defaultValue="config" className="w-full">
          <TabsList className="grid w-full max-w-md grid-cols-3">
            <TabsTrigger value="config">Konfiguracja</TabsTrigger>
            <TabsTrigger value="templates">Szablony</TabsTrigger>
            <TabsTrigger value="logs">Historia</TabsTrigger>
          </TabsList>

          <TabsContent value="config" className="mt-6">
            <EmailConfigTab settings={data.emailSettings} />
          </TabsContent>

          <TabsContent value="templates" className="mt-6">
            <EmailTemplatesTab />
          </TabsContent>

          <TabsContent value="logs" className="mt-6">
            <EmailLogsTab />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
};
